module.exports = __webpack_public_path__ + "Mapa-Mobile.080f994a1d6291238d1ec0f5fe3c68de.png";